export enum MethodTypeFlow {
	Create = "CreateCategory",
	Update = "UpdateCategory",
	Delete = "DeleteCategory",
}
